import React from 'react';
import { plansData } from '../../data/plansData';
import whiteTick from '../../assets/whiteTick.png';
import './Plans.css';

const Plans = () => {
  return (
    <div className="plans-container">
        <div className="blur plans-blur-1"></div>
        <div className="blur plans-blur-2"></div>
        <div 
            className="programs-header"
            style={{ gap: '2rem' }}
        >
            <span className="stroke-text">მზად ხარ</span>
            <span>შენი მოგზაურობის დასაწყებად</span>
            <span className="stroke-text">ჩვენთან ერთად?</span>   
        </div>
        <div className="plans">
            {plansData.map((plan, i) => (
                <div className="plan" key={i}>
                    {plan.icon}
                    <span>{plan.name}</span>
                    <span>${plan.price}</span>

                    <div className="features">
                        {plan.features.map((feature, i) => (
                            <div className="feature" key={i}>
                                <img src={whiteTick} alt="თიკი" />
                                <span>{feature}</span>
                            </div>
                        ))}
                    </div>     
                    <div>
                        <span>გაიგე მეტი უპირატესობების შესახებ →</span>
                    </div>    
                    <button className="btn">შემოგვიერთდი</button>
                </div>  
            ))}
        </div>
    </div>
  );
};

export default Plans;
